import type { DefaultDashboardDefinition } from './dashboard-definition';

export const locationDashboard: DefaultDashboardDefinition = {
  id: "configuration.location",
  appId: "configuration",
  name: "Location dashboard",
  record: {
    separator: ".",
    suffix: "summary",
    placementIds: "static",
    placementSeparator: ".",
  },
  queryScope: {
    field: "site_id",
    fieldsBySource: {
      "inventory.storage-locations": "site_location_id",
      "hr.current-employments": "location_id",
    },
    mode: "replace",
  },
  placements: [
    {
      id: "location.storage-count.default",
      widgetId: "location.storage-count",
      placement: {
        x: 0,
        y: 0,
        width: 3,
        height: 1,
      },
    },
    {
      id: "location.employee-count.default",
      widgetId: "location.employee-count",
      placement: {
        x: 3,
        y: 0,
        width: 3,
        height: 1,
      },
    },
    {
      id: "location.on-hand.default",
      widgetId: "location.on-hand",
      placement: {
        x: 6,
        y: 0,
        width: 3,
        height: 1,
      },
    },
    {
      id: "location.inventory-value.default",
      widgetId: "location.inventory-value",
      placement: {
        x: 9,
        y: 0,
        width: 3,
        height: 1,
      },
    },
    {
      id: "location.value-trend.default",
      widgetId: "location.value-trend",
      placement: {
        x: 0,
        y: 1,
        width: 6,
        height: 3,
      },
    },
    {
      id: "location.movement-trend.default",
      widgetId: "location.movement-trend",
      placement: {
        x: 6,
        y: 1,
        width: 6,
        height: 3,
      },
    },
    {
      id: "location.storage-types.default",
      widgetId: "location.storage-types",
      placement: {
        x: 0,
        y: 4,
        width: 12,
        height: 4,
      },
    },
  ],
};
